import { SessionStorage, Storage } from '@/utils/storage'
import CacheKey from '@/utils/cache/key'
import { ITheme } from '@/store/theme/interface'
import { themeConfig } from '@/store/theme/config'

// 缓存
class Cache {
	getToken = (): string => {
		return Storage.getItem(CacheKey.TokenKey) || ''
	}

	setToken = (value: string) => {
		Storage.setItem(CacheKey.TokenKey, value)
	}

	getTenantId = (): string => {
		return Storage.getItem(CacheKey.TenantId) || ''
	}

	setTenantId = (value: string) => {
		Storage.setItem(CacheKey.TenantId, value)
	}

	getRefreshToken = (): string => {
		return Storage.getItem(CacheKey.RefreshTokenKey) || ''
	}

	setRefreshToken = (value: string) => {
		Storage.setItem(CacheKey.RefreshTokenKey, value)
	}

	getUserInfo = (): any => {
		return Storage.getItem(CacheKey.UserInfoKey) || null
	}

	setUserInfo = (value: any) => {
		Storage.setItem(CacheKey.UserInfoKey, value)
	}

	removeUserInfo = () => {
		Storage.removeItem(CacheKey.UserInfoKey)
	}

	getSidebarOpened = (): boolean => {
		return Storage.getItem(CacheKey.SidebarOpenedKey) || false
	}

	setSidebarOpened = (value: boolean) => {
		Storage.setItem(CacheKey.SidebarOpenedKey, value)
	}

	getLanguage = (): string => {
		return Storage.getItem(CacheKey.LangKey) || 'zh-CN'
	}

	setLanguage = (value: string) => {
		Storage.setItem(CacheKey.LangKey, value)
	}

	getComponentSize = (): string => {
		return Storage.getItem(CacheKey.ComponentSizeKey) || 'small'
	}

	setComponentSize = (value: string) => {
		Storage.setItem(CacheKey.ComponentSizeKey, value)
	}

	getTheme = (): ITheme => {
		return (SessionStorage.getItem(CacheKey.ThemeKey) as ITheme) || themeConfig
	}

	setTheme = (value: ITheme) => {
		SessionStorage.setItem(CacheKey.ThemeKey, value)
	}

	removeTheme = () => {
		SessionStorage.removeItem(CacheKey.ThemeKey)
	}

	getDictList = (): any[] => {
		return Storage.getItem(CacheKey.DictListKey) || []
	}

	setDictList = (value: any[]) => {
		Storage.setItem(CacheKey.DictListKey, value)
	}

	removeDictList = () => {
		Storage.removeItem(CacheKey.DictListKey)
	}

	getAuthorityList = (): any[] => {
		return Storage.getItem(CacheKey.AuthorityListKey) || []
	}

	setAuthorityList = (value: any[]) => {
		Storage.setItem(CacheKey.AuthorityListKey, value)
	}

	removeAuthorityList = () => {
		Storage.removeItem(CacheKey.AuthorityListKey)
	}
	getShowPlat = (): number => {
		return Storage.getItem(CacheKey.ShowPlatKey) || 0
	}
	setShowPlat = (value: number) => {
		Storage.setItem(CacheKey.ShowPlatKey, value)
	}

	// 清除所有用户相关数据
	clearUserData = () => {
		// 清除用户认证相关数据
		Storage.removeItem(CacheKey.TokenKey)
		Storage.removeItem(CacheKey.RefreshTokenKey)
		this.removeUserInfo()
		localStorage.removeItem('customTitle')
		// 清除权限和字典数据
		this.removeAuthorityList()
		this.removeDictList()
	}
}

export default new Cache()
